<template>
  <div class="site">
    <div id="site-id" class="hidden"></div>
    <el-row :gutter="10">
      
      <!-- FIELD LIST - LEFT PANEL -->
      <el-col :lg="{span: 16}" :md="{span: 16}" :sm="{span: 16}" :xs="{span: 24}">
        <div class="panelheader">
          <div class="title">Lighting Control</div>
        </div>
        <el-table
          :data="fieldList"
          height="582"
          style="width: 100%"
          class="field-table"
          @row-click="fieldDetails"
          empty-text="No Fields">
            <el-table-column
            prop="field_name"
            label="Name"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="field_no"
            label="Field Number"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="light_status"
            label="Light Status"
            header-align="center">
            <template slot-scope="props">
              <el-tag 
                v-loading="lightStatusLoading" 
                element-loading-text="Syncing status..."
                element-loading-spinner="el-icon-loading"
                :type="statusTag(props.row).type">
                {{ statusTag(props.row).label }}
              </el-tag> 

                <!-- <div v-if="scope.row.light_status === 1">
                  <el-tag type="success">{{ getSceneName(scope.row.id) }}</el-tag>
                </div>
                <div v-else-if="scope.row.light_status === 2">
                  <el-tag type="warning">Standby</el-tag>
                </div>
                <div v-else>
                  <el-tag type="danger">Off</el-tag>
                </div> -->

            </template>
          </el-table-column>

          <el-table-column
            prop="id"
            label="Time Off"
            header-align="center">
            <template slot-scope="props">
              <!-- {{ statusTag(props.row).time_off }} -->
              <timer 
                v-if="!lightStatusLoading"
                :fieldId="props.row.id" 
                :fieldStatus="props.row.light_status"
                :endTime="props.row.end_time"
                @zeroTime="onZeroTime(props.row)">
              </timer>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      
      <!-- SITE INFORMATION - TOP RIGHT PANEL -->
      <el-col :lg="{span: 8}" :md="{span: 8}" :sm="{span: 8}" :xs="{span: 24}">
        <site-profile></site-profile>
      </el-col>

      <!-- ASTRO CLOCK - BOTTOM RIGHT PANEL -->
      <el-col :lg="{span: 8}" :md="{span: 8}" :sm="{span: 8}" :xs="{span: 24}" style="float:right">
        <astro-clock :sunsetOffset="sunsetOffset" :offTime="lights.off" v-on:updateAllLights="updateAllLights"></astro-clock>
      </el-col>

      <sitediag :fields="fieldList" :innerWidth.sync="innerWidth"></sitediag>

    </el-row>
    
    <!-- SITE BOOKING INFORMATION - BOTTOM PANEL -->
    <el-row>
      <el-col :xs="24" class="bookings">
        <siteBookings v-if="!reloadingBookings"></siteBookings>
      </el-col>
    </el-row>

  <!-- MODAL -->
  <el-dialog class="field_modal" v-bind:title="fieldData.field_name" :visible.sync="dialogVisible" :width="modalSize">
    <el-form :model="fieldData" :rules="rules" ref="fieldForm">
      <el-form-item label="Pick a Scene" prop="scene" required>
        <el-select v-model="fieldData.scene" placeholder="Pick a Scene" empty-text="No fields">
          <el-option
            v-for="item in scenes"
            :key="item.scene_id"
            :label="item.scene_name"
            :value="item.scene_id.toString()">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Pick a Time">
        <el-select v-model="fieldData.time" placeholder="Pick a Duration" v-on:change="calcEndTime">
          <el-option
            v-for="item in times"
            :key="item.id"
            :label="item.label"
            :value="item.time">
          </el-option>
        </el-select>
      </el-form-item>
      
      <div class="clear"></div>
      <div class="or">OR</div>
      <div class="clear"></div>
      <el-slider
        v-model="time"
        :step="10"
        show-stops
        :format-tooltip="formatVal">
      </el-slider>
      <el-form-item label="Finish At"><div class="end_time">{{endTime}}</div></el-form-item>
      <el-button type="save" v-on:click="updateField(fieldData, 'on')" v-loading.body="loading" element-loading-text="This sometimes takes up to 20 seconds...">Set Scene and Time</el-button>
    </el-form>
    <div v-if="!loading">
      <el-button class="lights_on" type="save" v-on:click="updateLights(fieldData, 'override')">Override On</el-button>
      <el-button class="lights_off" type="cancel" v-on:click="updateLights(fieldData, 'off')">Lights Off</el-button>
    </div>
    <div v-else>
      <div class="clear"></div>
      <div class="placeholder">Empty..</div>
    </div>
  </el-dialog>

  </div>
</template>


<script>

  import auth from '../auth'
  import requests from '../requests';
  import siteBookings from './SiteBookings.vue';
  import siteProfile from './SiteProfile.vue';
  import astroClock from './SiteAstroClock.vue';
  import siteDiag from './SiteDiagnostic.vue';
  import timer from './Timer.vue';

  import { formatTime, getHourTime, formatTimeStr, addTime, getNearestHalfHour, convertTo24Hr } from '../javascript/helpers'
  var socket = io();

  export default {
    name: 'site',
    data(){
      return {
        pageName: "Site Information",
        dialogVisible: false,
        clock:{
          sunset_time:'',
          sunset_description1:new Date().toString(),
          sunset_description2:'Sunset in Brisbane QLD'
        },
        lights:{
          on:'',
          off:''
        },
        fieldsScenes: [],
        fieldList:[],
        fieldData:{
          scene: '',
          time: ''
        },
        scenes: [],
        sceneDisabled: true,
        times: [
          {id: 1, time: 0.016, label:"1 Minute"},
          {id: 2, time: 0.033, label:"2 Minutes"},
          {id: 3, time: 0.25, label:"15 Minutes"},
          {id: 4, time: 0.5, label:"30 Minutes"},
          {id: 5, time: 0.75, label:"45 Minutes"},
          {id: 6, time: 1, label:"1 Hour"},
          {id: 7, time: 1.5, label:"1 Hour 30 Minutes"},
          {id: 8, time: 2, label:"2 Hours"}
        ],
        time: '10',
        endTime:'',
        id: '',
        rules: {
          scene:[{required: true, message: 'Please select a scene', trigger: 'blur'}]
        },
        loading: false,
        modalSize: '50%',
        innerWidth: 0,
        sunsetOffset: 0,
        fieldsFullScenes: [],
        lightStatusLoading: false,
        timerReloading: false,
        reloadingBookings: false,
      }
    },
    socket: {
      events: {
        lights_on: function(field_id){
          var context = this;
          this.fieldList.forEach(function(field, i){
            if(field.id == field_id){
              context.fieldList[i].light_status = 1;
            }
          });
          console.log('Turning light on for: ' + field_id);
        },
        lights_off: function(field_id){
          var context = this;
          this.fieldList.forEach(function(field, i){
            if(field.id == field_id){
              context.fieldList[i].light_status = 0;
            }
          });
          console.log('Turning light off for: ' + field_id);
        },
        all_lights_on: function(site_id){
          var context = this;
          if(this.id && this.id == site_id){
            console.log('Turning all lights on');
            this.fieldList.forEach(function(field, i){
              context.fieldList[i].light_status = 1;
            });
          }
          
        },
        all_lights_off: function(site_id){
          var context = this;
          if(this.id && this.id == site_id){
            console.log('Turning all lights off');
            this.fieldList.forEach(function(field, i){
              context.fieldList[i].light_status = 0;
            });
          }
          
        },
        delete_current_booking: function(field_id){
          console.log('deleting: ' + field_id);
          var context = this;
          this.fieldList.forEach(function(field, i){
            if(field.id == field_id){
              context.fieldList[i].light_status = 0;
            }
          });
        },
        standby_on: function(field_id){
          var context = this;
          this.fieldList.forEach(function(field, i){
            if(field.id == field_id){
              context.fieldList[i].light_status = 2;
            }
          });
        },
        error(err) {
          console.error("Websocket error: ", err);
        }
      }
    },
    beforeMount(){
      
      this.id = this.$route.params.id;
      var header = {headers: auth.getAuthHeader()};
      var profile = JSON.parse(auth.getProfile());
      var uri = auth.getApi();
      var context = this;

      this.$http.get(uri + '/api/fields/' + this.$route.params.id,{headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
        var fields = result.body.data;
        for(var i = 0; i < fields.length; i++){
          this.fieldList.push(fields[i]);
        }

        // requests.getFieldsScenes(context, function(res){
        //   if(res.action === 'success') {
        //     context.fieldsScenes = res.data;
        //   }
        // });

        context.updateFieldsScenes();

        requests.getFieldsOnSiteFullScenes(context, context.id, function(res) {
          if(res.action == 'success') {
            context.fieldsFullScenes = res.data;
          }
        })
      });

      this.$http.get(uri + '/api/site/' + this.$route.params.id,{headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
        var site = result.body.data;
        var t = formatTimeStr(site.auto_off_time);
        this.lights.off = formatTime(t.h, t.m) + getHourTime(t.h);

        context.sunsetOffset = site.sunset_offset || 0;
      });
    },
    mounted(){
      this.innerWidth = window.innerWidth;
    
      window.addEventListener('resize', () => {
        this.innerWidth = window.innerWidth;
      })
    },
    components:{
      'siteBookings':siteBookings,
      'site-profile':siteProfile,
      'astro-clock':astroClock,
      'sitediag': siteDiag,
      'timer':timer
    },
    methods:{
      updateLights(field, status){

        var confirmOffForMetalHalide = new Promise((resolve, reject) => {
          if(field.light_type_id != 3 && field.light_type != 'Metal Halide') { return resolve(true) }
          if(status != 'off' && status != 0) { return resolve(true) }
          if(!field.min_off_time) { return resolve(true) }

          this.$confirm((<span> <div>This is a <strong>Metal Halide</strong> light.</div>
          <div> If turned off it <strong>cannot</strong> be turned on for another <strong>{ encodeURI(field.min_off_time)} minutes.</strong>
          </div> </span>), 'Warning', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning'  
          }).then(() => {
            resolve(true);
          }).catch(() => {
            resolve(false);
          });
        });

        confirmOffForMetalHalide.then((actionConfirmed) => {

          if(!actionConfirmed) {
            return
          }
        
          var index = this.findIndexFromId(field.id);
          var time = convertTo24Hr(this.lights.off);
          try {
            var field_name = this.fieldList[index].field_name;
          } catch(err){
            console.log(`Could not get field name. Index ${index} could not be found in field list`);
            this.$message({
              type: 'error',
              message: 'Error finding field id'
            });
            context.loading = false;
            return;
          }

          var scene_id = this.fieldData.scene;

          var statusStr = status;
          status = status === 'on' ? 1 : 0;

          if(status == 0) {
            if(statusStr === 'override') {
              status = 1;
              var fullScenes = this.fieldsFullScenes.filter(v => v.field_id == field.id);
              if(!fullScenes.length) {
                this.$message({
                  type: 'warning',
                  message:
                    (<p>
                      <h3>No override scene set for {field_name}.</h3>
                      <div>Please set scene manually and contact your administrator.</div>
                    </p>),
                  showClose: true,
                })
                return;
              } else {
                scene_id = fullScenes[0].on_scene;
              }
              statusStr = 'on'
            }
          } else {
            time = this.endTime;
          }

          var header = {headers: auth.getAuthHeader()};
          var id = this.fieldList[index].id;
          var data = {
            off_time: time,
            scene_id: scene_id,
            field_id: this.fieldData.id,
            light_status: status
          }

          var uri = auth.getApi();
          var context = this;
          this.$http.put(uri + '/api/field/light/' + id, data, {headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
            var res = result.body;
            context.loading = false;
            console.log(res);
            if(res.action == 'success'){
              context.dialogVisible = false;
              //context.fieldList[index].light_status = status;
              this.$message({
                showClose: true,
                type: 'success',
                message: 'Successfully turned ' + field_name + '\'s lights ' + statusStr.toUpperCase()
              });

              context.updateFieldsScenes();

              return;
            } else {
              return;
            }
          }).catch((res) => {
              this.$message({
                showClose: true,
                type: 'error',
                message: res.body.msg
              });
              context.loading = false;
          });

        });
      },
      updateAllLights(status){
        var statusStr = status == 0 ? 'Off':'On';
        var time = convertTo24Hr(this.lights.off);

        this.dialogVisible = false;
        var header = {headers: auth.getAuthHeader()};
        var data = {light_status: status, auto_off_time:time};
        var uri = auth.getApi();
        this.$http.put(uri + '/api/field/lights/all/' + this.$route.params.id, data, {headers:{'x-access-token':header['headers']['x-access-token']}}).then(res=>{
          this.updateFieldsScenes();
          if(res.body.action === "success"){
            this.$message({
              showClose: true,
              type: 'success',
              message: 'All lights turned ' + statusStr
            });
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.body.msg
            });
          }
        }).catch((res) => {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.body.msg
            });
        });
      },
      formatTime(time){
        var t = formatTimeStr(time);
        return formatTime(t.h, t.m) + getHourTime(t.h);
      },
      fieldDetails(row, event){
        var id = row.id;
        var header = {headers: auth.getAuthHeader()};
        var uri = auth.getApi();
        this.$http.get(uri + '/api/field/' + id,{headers:{'x-access-token':header['headers']['x-access-token']}}).then(result=>{
          if(result && result.body && result.body.action == "success" && result.body.data){
            if(!result.body.data.scenes){
              console.log('no scenes');
              this.$message({
                showClose: true,
                type: 'error',
                message: "No scenes found for field"
              });
              return false;
            }
            var field = result.body.data;
            field.time = null;
            field.scene = null;
            this.fieldData = field;
            this.dialogVisible = true;
                        
            this.scenes = field.scenes;
            if(this.scenes){
              this.sceneDisabled = false;
            } else {
              this.sceneDisabled = true;
            }
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: result.body.msg
            });
          }
        });
      },
      //Method to update the field data for turning lights on (time, and scene)
      updateField(field, status){
        
        var index = this.findIndexFromId(field.id);
        
        this.$refs['fieldForm'].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            var header = {headers: auth.getAuthHeader()};
            
            //console.log(this.endTime);
            //var ampm = this.endTime.match(/[A-Za-z]+/)[0];
            
            this.endTime = convertTo24Hr(this.endTime);
            var data = {
              off_time: this.endTime,
              scene: this.fieldData.scene,
              id: this.fieldData.id
            }
            this.fieldList[index].off_time = this.endTime;
            var uri = auth.getApi();
            this.loading = true;
            this.updateLights(field, status);
          }
        });
      },
      calcEndTime(){
        var add = this.fieldData.time;
        var unformattedTime = addTime(new Date(), add);
        var splitTime = unformattedTime.split(' ');
        var tStr = splitTime[0];
        var t = formatTimeStr(tStr);
        var rT = formatTime(t.h, t.m) + getHourTime(t.h);
        this.endTime = rT;
      },
      formatVal(val){
        var hrs = (val * 3) / 60;
        var halfHr = getNearestHalfHour();
        var unformattedTime = addTime(halfHr, hrs);
        var splitTime = unformattedTime.split(' ');
        var tStr = splitTime[0];
        var t = formatTimeStr(tStr);
        var rT = formatTime(t.h, t.m) + getHourTime(t.h);
        this.endTime = rT;
        return rT;
      },
      getSceneName(id) {
        if(this.fieldsScenes){
          for (var i = 0; i < this.fieldsScenes.length; i++) {
            var fs = this.fieldsScenes[i];
            if(fs.field_id == id) {
              return fs.scene_name;
            }
          }
          return "On";
        } else {
          console.log(`Error processing getSceneName in Site.vue for field ${id}`);
          return "On";
        }
        
      },
      findIndexFromId(id){
        for(var i = 0; i < this.fieldList.length; i++){
          if(this.fieldList[i].id == id){
            return i;
          }
        }
        return -1;
      },
      statusTag(row) {
        var type = 'danger', label = 'Off';

        if(this.fieldsScenes && this.fieldsScenes.length) {
          var fs = this.fieldsScenes.filter(v => v.field_id == row.id);
          if(fs.length) {
            label = fs[0].scene_name || 'On';
            type = 'success';
            row.end_time = fs[0].end_time;
          }
        }

        if (row.light_status == 2) {
          type = 'warning';
          label = 'Standby'
        }

        return {type, label};
      },
      updateFieldsScenes(){
        // This is badly named but get's the current scene name if it's on        
        var context = this;
        this.lightStatusLoading = true;
        this.reloadingBookings = true;

        this.$nextTick(() => { this.reloadingBookings = false });

        setTimeout(() => {

          requests.getFieldsScenes(this, function(res){
            context.lightStatusLoading = false;
            if(res.action === 'success') {
              context.fieldsScenes = res.data;
            }
          });

        }, 3000);
      },
      onZeroTime(row) {
        row.end_time = 0;
        this.updateFieldsScenes();
      }
    },
    watch: {
      innerWidth(value) {
        if(value < 780) {
          this.modalSize = '100%';
        } else {
          this.modalSize = '50%';
        } 
      }
    }
    
  }
</script>


<style>
  .site .fa-icon {
    width: auto;
    height: 1em; /* or any other relative font sizes */
    margin-right: 4pt;
  }
  
  .site_info {
    text-align: left;
    margin-left: 25pt;
  }
  
  .site_name {
    font-size: 1.7em;
    font-weight: 500;
    padding-top: 14pt;
    padding-bottom: 8pt;
  }
  
  .site_address {
    text-transform: uppercase;
    color: #656565;
    padding-top: 4pt;
    padding-bottom: 18pt;
    font-size: 1.4em;
  }
  
  .site_contact {
    font-size: 1.3em;
    color: #656565;
  }
  
  .panel .phone {
    padding-bottom: 20pt;
  }
  
  .panel {
    background-color: white;
  }
  
  .site_lights img {
    margin-top: 10pt;
    height: 45pt;
  }
  
  .site_lights {
    text-align: left;
    padding-left: 25pt;
  }
  
  .light_btns {
    padding-top: 15pt;
    padding-bottom: 20pt;
  }
  
  .light_btns .label {
    display: block;
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 10pt;
  }
  
  .sunset {
    font-size: 24px;
    padding-bottom: 0.8em;
  }
  
  .sunset_desc {
    padding-bottom: 0.2em;
    color: #656565;
  }
  
  .lights_desc {
    padding-top: 18pt;
    font-size: 14px;
  }
  
  .lights_desc div {
    padding-top: 0.4em;
  }
  
  .subpanelheader {
    margin-top: 1.8em;
  }
  
  .field-table {
    padding:0.8em;
  }
  
  .field-table tr th {
    background-color: white;
  }
  
  .field-table tr th .cell {
    background-color: white;
    font-size: 1.1em;
  }
  
  .field-table tr td .cell {
    padding: 8pt;
  }

  .field-table .el-table__row {
    cursor: pointer;
  }
  
  .scene-col {
    color: #656565;
  }
  
  .field_modal .el-form-item__content {
    float: right;
  }
  
  .end_time {
    font-size: 1.4em;
    color: #656565;
    text-align: center;
    float: unset;
  }
  
  .lights_off {
    margin-top: 20pt;
  }
  
  .astro-clock > .panelheader {
    margin-top: 1em;
  }
  
  .placeholder {
    color: white;
    padding: 5pt;
    margin: 6pt;
  }

  .diag-button {
    padding-bottom: 30px;
    text-align: left;
  }

  .diag-button .el-button {
    margin-left: 40px; 
  }

</style>


// WEBPACK FOOTER //
// Site.vue?41cf178b